import { ReactElement } from 'react';
import { CalendarContainerProps } from 'react-datepicker';
import Card from '../Card';

function DateInputCalendarContainer({ arrowProps, showPopperArrow, ...rest }: CalendarContainerProps): ReactElement {
  return <Card role="dialog" {...rest} />;
}

export default DateInputCalendarContainer;
